



















import {Component, Prop} from "vue-property-decorator"
import AbpBase from "../../../../lib/abpbase"
import AddOrEdit from './addOrEdit.vue'

@Component({
	components: {AddOrEdit}
})
export default class Show extends AbpBase{
	@Prop({type:Boolean,default:false}) value:Boolean
	@Prop() data:any
	@Prop({type:Array}) types:Array<any>
	addOrEditShow = false
	addOrEditData:any = {}
	// get data(){
	// 	return this.datas
	// }
	get imgs(){
		return this.data.contentImagePath.split(';')
	}
	editOne(){
		this.addOrEditData = {
			mode: 'edit',
			data: this.data
		}
		this.addOrEditShow = true
	}
	created(){
		console.log(this.imgs)
		console.log(this.data)
	}
	saveSuccess(){
		this.$emit('edit-save-success')
	}
	get width(){
		return window.innerWidth - 300
	}
	get height(){
		return (window.innerHeight - 150) + 'px'
	}
	get dialogTitle(){
		return this.data.resourceTitle
	}
	visibleChange(value:boolean){
		if(!value){
			this.$emit('input',value);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/education/warehouse/parts/show.vue